/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FinchEmployeeSyncType {
  SSN = 'SSN',
  EMAIL = 'EMAIL',
  MANUAL = 'MANUAL',
}
